import PropTypes from 'prop-types';
import cn from 'classnames';

require('./mobileHeader.scss');

export default function MobileHeader ({ buttons=[],
                                        className=''
                                      }) {

  const createButton = (button, index) => {
    if (!button) {
      return null;
    }
    if (button.buttonComponent) {
      const {buttonComponent: ButtonComponent, ...props} = button;
      return <ButtonComponent key={index}  {...props} />;
    }
    const {id, action, actionData, className, icon: Icon, label, ...other } = button;
    return (
      <div
        {...other}
        key={index}
        id={id}
        className={cn('mobile-header-item', className ?? '')}
        onClick={() => {action?.(actionData)}}
    >
      {Icon ? <Icon/> : ''} {label ?? ''}
    </div>);
  };

  return (
    <div className={cn('mobile-header', className)}>
      {buttons.map((b, index ) => createButton(b, index))}
    </div>
  );
}

MobileHeader.propTypes = {
  buttons: PropTypes.array,
  className: PropTypes.string,
};


